import React, {useState} from 'react';

import './EndTurnButton.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";
import {SoundsService} from "../../../services/SoundsService";
import {sounds} from "../../../sounds/sound";


function EndTurnButton() {

    const {tutorial, user} = useTypedSelector(state => state.auth);
    const {phase, playerAD, playerTable, playerTurn, playerMulligan} = useTypedSelector(state => state.game);
    const [showButtons, setShowButtons] = useState(true);
    const {endTurn, setPlayerAD} = useActions();

    let rootClasses = 'endTurnButton';

    const canShowEndTurnButton =
        (
            user.level < 3 ||
            (playerTurn !== 1 || playerMulligan)
        ) &&
        (phase === 'play_card' || phase === 'enemy_turn');

    if (canShowEndTurnButton) {
        rootClasses += ' endTurnButtonActive';
    }

    let stateClasses = ' justEndTurn';

    let counterReadyToAttack = 0;
    for (let i = 0; i < 5; i++) {
        if (playerTable[i] !== 0 && playerTable[i] !== null) {
            if (playerTable[i].sleep === true || playerTable[i].card.attack < 1) {
                continue;
            }
            if (playerTable[i].card.ability !== null && playerTable[i].card.ability.type_effect === 'wall') {
                continue;
            }

            if (playerTable[i].effect !== undefined && playerTable[i].effect.stun !== undefined) {
                continue;
            }


            if (playerAD[i] === true) {
                stateClasses = ' AttackEndTurn';
            } else {
                counterReadyToAttack++;
            }
        }
    }

    if (phase === 'enemy_turn') {
        stateClasses = ' endTurnEnemyTurn';
    }

    const setAllAttack = async () => {
        setShowButtons(false);
        for (let i = 0; i < 5; i++) {
            if (playerAD[i] === false && playerTable[i] !== 0 && playerTable[i] !== null) {
                if (playerTable[i].sleep === true || playerTable[i].card.attack < 1) {
                    continue;
                }
                if (playerTable[i].card.ability !== null && playerTable[i].card.ability.type_effect === 'wall') {
                    continue;
                }
                if (playerTable[i].effect !== undefined && playerTable[i].effect.stun !== undefined) {
                    continue;
                }

                playerAD[i] = true;
                setPlayerAD(playerAD);
                SoundsService.playSound(sounds.battle_unit_set_attack());
                await new Promise(r => setTimeout(r, 100));

            }
        }
        setShowButtons(true);
    }

    let tutorialClasses = '';
    if (tutorial.isActive && (tutorial.step === 'SelectAttack60' || tutorial.step === 'PlaySpellCard70' || tutorial.step === 'PlayFirstCard40' || tutorial.step === 'PlaySecondCard50')) {
        tutorialClasses = ' endTurnContainerTutorial';
    }

    return showButtons ? (
        <div className={'endTurnContainer'}>
            <div
                className={rootClasses + stateClasses + tutorialClasses}
                onClick={() => {
                    if (phase === 'play_card') {
                        endTurn();
                    }
                }}
            ></div>

            {(counterReadyToAttack > 0 && phase === 'play_card')
                ? (
                    <div
                        className={'allAttackButton' + tutorialClasses}
                        onClick={() => {
                            setAllAttack();
                        }}
                    ></div>
                )
                : <div></div>
            }
        </div>
    ) : (
        <div></div>
    );
}

export default EndTurnButton;